export function isInteger(value: unknown): boolean {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
